import React from 'react';
import s from './moneyBack.module.scss';
import locales from '../../../content.json';

interface MoneyBackProps {
  style2?: boolean;
  product?: unknown;
}

export const MoneyBack = ({ style2 }: MoneyBackProps) => {
  return (
    <div className={style2 ? `${s.moneyBack_wrapper} ${s.moneyBack_wrapper_style2}` : s.moneyBack_wrapper}>
      <p className={s.moneyBack_text1}>{locales[window.userLang].payment_text_197}</p>
      <div className={s.moneyBack_block}>
        <p className={s.moneyBack_text2}>{locales[window.userLang].payment_text_198}</p>
        <p className={s.moneyBack_text3}>{locales[window.userLang].payment_text_199}</p>
        <p className={s.moneyBack_text4} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_200}} />
      </div>
    </div>
  );
};
